// extracted by mini-css-extract-plugin
module.exports = {"FetchMultiselectContainer":"FetchMultiselect_FetchMultiselectContainer__3-Tlx"};